export default __webpack_public_path__ + "static/media/work.2e4ef256.svg";